import queries from '@apis/queries';
import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Row from '@components/Row';
import Switch from '@components/Switch';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import useToggleLocationAgreement from './hooks/useToggleLocationAgreement';
import useToggleMarketingAgreement from './hooks/useToggleMarketingAgreement';

/**
 * 위치 정보, 마케팅 수신 동의
 * @constructor
 */
function Permissions() {
    const { t } = useTranslation('accountSetting');
    const { data: user } = useQuery(queries.user.detail());
    const toggleMarketingAgreement = useToggleMarketingAgreement();
    const { toggleLocationAgreement, locationAgreed } = useToggleLocationAgreement();

    return (
        <Accordion title={t('permissions.title')}>
            <Contents
                spacing={16}
                fullWidth>
                <Row fullWidth justify='space-between'>
                    <Text color={colors.gray7} size='lg'>
                        {t('permissions.locationAgreement')}
                    </Text>
                    <Switch checked={locationAgreed}
                        setChecked={toggleLocationAgreement} />
                </Row>
                <Row fullWidth justify='space-between'>
                    <Text color={colors.gray7} size='lg'>
                        {t('permissions.marketingAgreement')}
                    </Text>
                    <Switch checked={user?.marketingAgreed}
                        setChecked={toggleMarketingAgreement} />
                </Row>
            </Contents>
        </Accordion>
    );
}

const Contents = styled(Column)`
    padding: 6px 0 40px;
`;

export default Permissions;
